import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../../services/auth/login.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, Validators } from '@angular/forms';
import { merge } from 'rxjs';
import { SettingsService } from '../../../services/setting-service/setting.service';
import { ModalService } from '../../../services/modal/modal.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.page.html',
    styleUrls: ['./login.page.scss'],
    standalone: false
})
export class LoginPage implements OnInit {

  allRightsReservedDate = new Date().getFullYear();

  enterEmail:boolean = true;
  enterCode:boolean = false;

  readonly email = new FormControl('', [Validators.required, Validators.email]);
  readonly code = new FormControl('', [Validators.required, Validators.minLength(5)]);

  errorMessage = signal('');
  loading:boolean = false;

  sendCount = 60;
  resendCode:boolean = false;

    constructor(private router: Router,
        private loginService: LoginService,
        private settingsService: SettingsService,
        private modalService: ModalService
    ) {
      merge(this.email.statusChanges, this.email.valueChanges, this.code.statusChanges, this.code.valueChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateErrorMessage());

        merge(this.code.statusChanges, this.code.valueChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateErrorMessage());
     }

    ngOnInit() {

    }

    ionViewDidEnter() {
        this.enterEmail = true;
        this.enterCode = false;
    }

    touchEnterCode() {
        this.enterEmail = false;
        this.enterCode = true;
    }

  updateErrorMessage() {
    console.log(this.code.errors)
    if (this.enterEmail) {
      if (this.email.hasError('required')) {
        this.errorMessage.set('Você tem que digitar um email');
      } else if (this.email.hasError('email')) {
        this.errorMessage.set('email inválido!');
      } else {
        this.errorMessage.set('');
      }
    } else {
        this.resendCode = true;
      if (this.code.hasError('required')) {
        this.errorMessage.set('Você tem que digitar um código válido.');
      } else if (this.code.hasError('code')) {
        this.errorMessage.set('código inválido!');
      } else {
        this.errorMessage.set('');
      }
    }

  }

    touchResendCode() {
        this.loginService.preLogin(this.email.value!).then((res: any) => {

            this.loading = false;
            console.log("?? ~ LoginPage ~ touchPreLogin ~ res:", res);
            if (res.status === 200) {
                this.touchEnterCode();
            } else {
                // Aplicar modal de erro quando status !== 200
                this.showError('Email não encontrado. Verifique suas credenciais e tente novamente.');
            }

        }).catch((err: any) => {
            this.loading = false;
            // Aplicar modal de erro em caso de exceção
            const errorMessage = err?.message || 'Ocorreu um erro ao tentar reenviar o código. Tente novamente.';
            this.showError(errorMessage);
        });

      for (let index = 0; index < 60; index++) {
        setTimeout(() => {
          this.sendCount--;
          if (this.sendCount === 0) {
               this.sendCount = 60;
          }
        }, index * 1000);
      }

    }

    touchPreLogin() {
        this.loading = true;
        this.loginService.preLogin(this.email.value!).then((res: any) => {
            this.loading = false;
            if (res.status === 200) {
                this.touchEnterCode();
            } else {
                this.showError('Email não encontrado. Verifique suas credenciais e tente novamente.');
            }

        }).catch((err: any) => {
            this.loading = false;
            const errorMessage = err?.error?.message || 'Ocorreu um erro ao tentar fazer login. Tente novamente.';
            this.showError(errorMessage);
        });
    }


    touchLogin() {
        this.loading = true;
        this.loginService.login(this.email.value!, this.code.value!).then((res: any) => {
            this.loading = false;
            if (res.status === 200) {
                localStorage.setItem('USER_DATA', JSON.stringify(res.result));
               this.settingsService.user = res.result;
               this.settingsService.logado = true;
                this.router.navigate(['/home']);
            }else{
              // Aplicar modal de erro quando status !== 200 na fase 2
              this.showError('Código inválido. Verifique o código recebido e tente novamente.');
            }
        }).catch((err: any) => {
            this.loading = false;
            // Aplicar modal de erro em caso de exceção
            const errorMessage = err?.message || 'Ocorreu um erro ao validar o código. Tente novamente.';
            this.showError(errorMessage);
        });
    }

    touchSignUp() {
        this.router.navigate(['/sign-up']);
    }

    goBack() {
        this.enterEmail = true;
        this.enterCode = false;
        this.email.setValue('');
    }

    goToRegulation() {
        this.router.navigate(['/regulation']);
    }

    async showError(message: string) {
        await this.modalService.showAlertModal({
            imagemUrl: '../../../../assets/icons/warning.svg',
            titleText: 'Ops! Algo deu errado',
            subtitleText: message,
            listButtons: [
                {
                    textButton: 'Ok',
                    fill: 'outline',
                }
            ]
        })
    }

}
